import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, breakpoints } from 'globalStyles'

const Branding = styled.h1`
  color: ${colors.dark_blue};
  font-size: 26px;
  line-height: 25px;
  font-weight: 400;
  margin-bottom: -8px !important;
  @media only screen and ${breakpoints.tablet} {
    font-size: 34px;
    line-height: 45px;
  }
  @media only screen and ${breakpoints.desktop} {
    font-size: 42px;
    line-height: 58px;
  }
`

export default () => {
  const { t } = useTranslation()

  return <Branding>{t('pyw')}</Branding>
}
